import { FC } from "react";
import { EyeIcon, EyeOffIcon } from "lucide-react-native";

import { VnIcon } from "@/components/VnIcon";
import { VnTouchableOpacity } from "@/components/VnTouchableOpacity";

type SecureTextEntryTogglePropsType = {
  isVisible: boolean;
  onPress: () => void;
};

export const SecureTextEntryToggle: FC<SecureTextEntryTogglePropsType> = ({
  isVisible,
  onPress,
}) => (
  <VnTouchableOpacity shouldDebounce={false} onPress={onPress}>
    <VnIcon
      as={isVisible ? EyeOffIcon : EyeIcon}
      className="text-muted-foreground"
      size={18}
    />
  </VnTouchableOpacity>
);
